module.exports = __webpack_public_path__ + "static/media/s9.65282205.webp";